export default {
  strict: true,
  namespaced: true,
  state: {
    reservations: {
      list: [],
      isMax: false,
      currentPage: 0,
      perPage: 20,
      search: '',
      status: '',
      date: 'last30Days',
      dateFrom: '',
      dateTo: '',
      sort: {
        order: 'created',
        isDesc: true
      },
      loading: false
    }
  },
  mutations: {
    resetReservations (state) { state.reservations.list = [] },
    addReservations (state, value) { state.reservations.list.push(value) },
    setReservationsIsMax (state, value) { state.reservations.isMax = value },
    setReservationsCurrentPage (state, value) { state.reservations.currentPage = value },
    // setReservationsFromTo (state, value) {
    //   state.reservations.from = value.from
    //   state.reservations.to = value.to
    // },
    resetRsvpFilters (state, value) {
      state.reservations.search = ''
      state.reservations.status = ''
      state.reservations.date = 'last30Days'
      state.reservations.dateFrom = ''
      state.reservations.dateTo = ''
      state.reservations.loading = false
    },
    setRsvpSearch (state, value) { state.reservations.search = value },
    setRsvpStatus (state, value) { state.reservations.status = value },
    setRsvpDate (state, value) { state.reservations.date = value },
    setRsvpDateFrom (state, value) { state.reservations.dateFrom = value },
    setRsvpDateTo (state, value) { state.reservations.dateTo = value },
    setRsvpSortColumn (state, value) { state.reservations.sort.column = value },
    setRsvpSortIsDesc (state, value) { state.reservations.sort.isDesc = value }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/consumer/reservations.js